<style lang="scss">
    @import "./homeLogin.css";
	#loginPage{
		height: 100vh;
	}
	.border_flag .el-input__inner{
		border-color: red;
	}
	.padding_left_big{
		padding: 3% 0 3% 21%;
	}
	.padding_left_eng{
		padding: 3% 5% 3% 18%;
	}
	.padding_right_big{
		padding: 3.5% 21% 3% 6.5%;
	}
	.padding_right_eng{
		padding: 3.5% 17% 3% 6.5%;
	}
	@media (min-width: 1024px) and (max-width: 1366px) {
		.padding_left_big{
			padding: 3% 0 3% 18%;
		}
		.padding_right_big{
			padding: 3.5% 15% 3% 6.5%;
		}
		.con_left_img_smail{
			width: 90% !important;
		}
	}
</style>
<template>
    <div id="loginPage" class="loginPage_book">
		<div class="login_top" :style="{padding: $i18n.locale == 'big5' ? '5px 21%' : '5px 18%'}">
			<img src="../../image/login/logo_top.png" class="login_top_img">
			<div class="login_lan">
				<img src="../../image/login/lan.png" style="margin-right: 20px;" class="login_lan_img">
				<div :class="{ 'login_lan_color': yyFlag }" style="cursor: pointer;" @click="language(1)">EN</div>
				<div style="margin: 0 12px;" class="login_lan_padding">|</div>
				<div :class="{ 'login_lan_color': !yyFlag }" style="cursor: pointer;" @click="language(2)">中文</div>
			</div>
		</div>
		<div class="login_con">
			<div class="con_left con_all" :class="$i18n.locale == 'big5' ? 'padding_left_big':'padding_left_eng'" >
				<div class="con_left_title" :class="$i18n.locale == 'big5' ? 'con_left_title_big':'con_left_title_eng'" >{{this.$t('login.khtitle')}}</div>
				<!-- khtext1 -->
				<div class="con_left_text">{{this.$t('login.khtext1')}}</div>
				<div class="con_left_flex con_left_flex_book" style=" margin-top: 40px;">
					<div class="con_left_num">1</div>
					<div class="con_left_numtext">{{this.$t('login.khtext2')}}</div>
				</div>
				<div class="con_left_flex">
					<div class="con_left_num">2</div>
					<div class="con_left_numtext">{{this.$t('login.khtext3')}}</div>
				</div>
				<div class="con_left_flex">
					<div class="con_left_num">3</div>
					<div class="con_left_numtext">{{this.$t('login.khtext4')}}</div>
				</div>
				<div class="con_left_flex">
					<div class="con_left_num">4</div>
					<div class="con_left_numtext">{{this.$t('login.khtext5')}}</div>
				</div>
				<div class="con_left_flex">
					<div class="con_left_num">5</div>
					<div class="con_left_numtext">{{this.$t('login.khtext6')}}</div>
				</div>
				<div class="con_left_flex">
					<div class="con_left_num">6</div>
					<div class="con_left_numtext">{{this.$t('login.khtext7')}}</div>
				</div>
				<div class="con_left_flex">
					<div class="con_left_num">7</div>
					<div class="con_left_numtext">{{this.$t('login.khtext8')}}</div>
				</div>
				<div class="con_left_prepare">{{this.$t('login.khzb')}}</div>
				<div class="con_left_img" :style="{width: $i18n.locale == 'big5' ? '65%' : '75%'}"  :class="{ 'con_left_img_smail': $i18n.locale != 'big5' }">
					<div>
						<img src="../../image/login/1.png" class="con_left_img_book">
						<div style="margin-top: 20px;" class="con_left_top_book">{{this.$t('login.idcard')}}</div>
					</div>
					<div style="">
						<img src="../../image/login/2.png" class="con_left_img_book">
						<div style="margin-top: 20px;" class="con_left_top_book">{{this.$t('login.pass')}}</div>
					</div>
					<div style="">
						<img src="../../image/login/3.png" class="con_left_img_book">
						<div style="margin-top: 20px;" class="con_left_top_book">{{this.$t('login.bankcard')}}</div>
					</div>
				</div>
			</div>
			<div class="con_right con_all" :class="$i18n.locale == 'big5' ? 'padding_right_big':'padding_right_eng'">
				<div class="con_right_title">{{this.$t('login.khtext9')}}</div>
				<div class="con_right_tab">
					<div :class="{ 'login_tab': numFlag }" style="cursor: pointer;" @click="tabClick(1)">{{this.$t('login.khtext10')}}</div>
					<div style="margin: 0 15px;">|</div>
					<div :class="{ 'login_tab': !numFlag }" style="cursor: pointer;"  @click="tabClick(2)">{{this.$t('login.khtext11')}}</div>
				</div>
				<!-- 手機號 -->
				<div  v-if="numFlag">
					<div class="con_right_phone">
						<div class="qhXz">
							<el-select v-model="form.qh"  @change="qhclick">
								<el-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value" :value="item.value" >
									<span class="qhXz_select_book" style="font-size:16px;float: left">{{ item.label }}</span>
									<span class="qhXz_select_book" style="font-size:16px;float: right;" v-if="item.id != 11">+{{ item.value }}</span>
								</el-option>
							</el-select>
							<div class="qhXz_div_book" style="position: absolute;width: 75%;background: #fff;top: 1px;height: 95%;display: flex;align-items: center;left: 5px;font-size: 18px;justify-content: center;" v-if="!qhflag">+ {{form.qh}}</div>
							<div class="qhXz_input_book" style="position: absolute;width: 75%;height:92%;top: 2px;left: 2px;background: #fff;display: flex;align-items: center;justify-content: center;" v-else>
								<div style="font-size: 18px;" class="qh_add">+&nbsp;</div>
								<el-input  class="qh_phone_class" type="number" v-model="form.qh" oninput="if(value.length>3)value=value.slice(0,3)" style="width: 50%;"></el-input>
							</div>
						</div>
						<el-input class="phone" :class="{ 'border_flag':  flag1}" @input="flag1 = false" v-model="form.phone" :placeholder="this.$t('login.phoneinput')" type="number" :oninput="form.qh == '852' ? 'if(value.length>8)value=value.slice(0,8)': form.qh == '86'? 'if(value.length>11)value=value.slice(0,11)'  : 'if(value.length>20)value=value.slice(0,20)'"></el-input>
					</div>
					 <!-- 驗證碼 -->
					  <div class="con_right_code">
						<el-input :class="{ 'border_flag':  flag2}" @input="flag2 = false" class="code" v-model="form.code" :placeholder="this.$t('login.vcodeinput')" type="text" maxlength="6" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" @keyup.enter.native="submitForm()"></el-input>
						<div class="btnCode"><span style="color:#ffffff" @click="codeFn">{{form.codeIndex}}</span><span style="color:#ffffff" v-if="form.codeIndex != $t('login.yanzhengma')">s{{$t('login.later')}}</span></div>
					</div>
					<!-- 按鈕 -->
					<div class="subBtnLogin" @click="submitForm()">{{this.$t('login.khbutton')}}</div>
				</div>
				<!-- 郵箱 -->
				<div  v-if="!numFlag">
					<div class="con_right_phone" style="margin-top: 30px;">
						<div class="qhXz">
							<el-select v-model="form.qh"  @change="qhclick" class="abc">
								<el-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value" :value="item.value" >
									<span class="qhXz_select_book" style="font-size:16px;float: left">{{ item.label }}</span>
									<span class="qhXz_select_book" style="font-size:16px;float: right;" v-if="item.id != 11">+{{ item.value }}</span>
								</el-option>
							</el-select>
							<div class="qhXz_div_book" style="position: absolute;width: 75%;background: #fff;top: 1px;height: 95%;display: flex;align-items: center;left: 5px;font-size: 18px;justify-content: center;" v-if="!qhflag">+ {{form.qh}}</div>
							<div class="qhXz_input_book" style="position: absolute;width: 75%;height:92%;top: 2px;left: 2px;background: #fff;display: flex;align-items: center;justify-content: center;" v-else>
								<div style="font-size: 18px;" class="qh_add">+&nbsp;</div>
								<el-input class="qh_phone_class" type="number" v-model="form.qh" oninput="if(value.length>3)value=value.slice(0,3)" style="width: 50%;"></el-input>
							</div>
						</div>
						<el-input @input="flag1 = false" :class="{ 'border_flag':  flag1}" class="phone" v-model="form.phone" :placeholder="this.$t('login.phoneinput')" type="number" :oninput="form.qh == '852' ? 'if(value.length>8)value=value.slice(0,8)': form.qh == '86'? 'if(value.length>11)value=value.slice(0,11)'  : 'if(value.length>20)value=value.slice(0,20)'"></el-input>
					</div>
					<!-- 郵箱 -->
					 <div style="margin-top: 30px;" class="con_right_email_book">
						<el-input @input="flag3 = false" @blur="yxClick()" :class="{ 'border_flag':  flag3}" v-model="form.email" :placeholder="this.$t('login.emailinput')" ></el-input>
					 </div>
					 <!-- 驗證碼 -->
					  <div class="con_right_code" style="margin-top: 30px;">
						<el-input @input="flag2 = false" :class="{ 'border_flag':  flag2}" class="code" v-model="form.code" :placeholder="this.$t('login.khtext12')" type="text" maxlength="6" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" @keyup.enter.native="submitForm()"></el-input>
						<div class="btnCode"><span style="color:#ffffff" @click="codeFn">{{form.codeIndex}}</span><span style="color:#ffffff" v-if="form.codeIndex != $t('login.yanzhengma')">s{{$t('login.later')}}</span></div>
					</div>
					<!-- 按鈕 -->
					<div class="subBtnLogin" @click="submitForm()">{{this.$t('login.khbutton')}}</div>
				</div>

				<div class="contact">{{this.$t('login.lxwm1')}}</div>
				<div class="contact_flex">
					<img src="../../image/login/phone.png" alt="">
					<div :style="{width: $i18n.locale == 'big5' ? '43%' : '50%'}" style="margin-left: 10px;flex-shrink: 0;">{{this.$t('login.ybcx')}}：</div>
					<div>(852) 3971 6919</div>
				</div>
				<div class="contact_flex">
					<img src="../../image/login/phone.png" alt="">
					<div  :style="{width: $i18n.locale == 'big5' ? '43%' : '50%'}" style="margin-left: 10px;flex-shrink: 0;">{{this.$t('login.jyrx')}}：</div>
					<div>(852) 3971 6928</div>
				</div>
				<div class="contact_flex">
					<img src="../../image/login/phone.png" alt="">
					<div :style="{width: $i18n.locale == 'big5' ? '43%' : '50%'}" style="margin-left: 10px;flex-shrink: 0;">{{this.$t('login.mfndzx')}}：</div>
					<div>4001 206 046</div>
				</div>
				<div class="contact_flex">
					<img src="../../image/login/email.png" alt="">
					<div :style="{width: $i18n.locale == 'big5' ? '43%' : '50%'}" style="margin-left: 10px;flex-shrink: 0;">{{this.$t('login.dy')}}：</div>
					<div>cs@qmis.com.hk</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>

    import https from '@/plugins/http.js';
    import apiUrl from '@/assets/api.js';

    import App from '@/assets/app.js';
    import language from '../main/mains.vue';

    export default {
		components: {
            language
        },
        data() {
            return {
				flag1:false,
				flag2:false,
				flag3:false,
				yyFlag:false,
				numFlag:true,
				qhflag:false,
				websta:this.$store.state.onlinestate,
				handenter:0,
                // 登錄表單值
                form:{
                    qh:'852',
                    phone:'',
                    email:'',
                    code:'',
                    codeIndex:this.$t('login.yanzhengma')
                },
                // 手機區號列表
                qhArr:[
                    {id:'1',value: '86',label: this.$t('login.zgdl')}, 
                    {id:'2',value: '852',label: this.$t('login.zgxg')}, 
                    {id:'3',value: '853',label: this.$t('login.zgam')}, 
                    {id:'4',value: '61',label: this.$t('login.adly')}, 
                    {id:'5',value: '1',label: this.$t('login.jnd')},
                    {id:'6',value: '60',label: this.$t('login.mlxy')},
                    {id:'7',value: '1',label: this.$t('login.mg')},
                    {id:'8',value: '65',label: this.$t('login.xjp')},
                    {id:'9',value: '64',label: this.$t('login.xxl')}, 
                    {id:'10',value: '44',label: this.$t('login.yg')},
                    {id:'11',value: '',label: this.$t('login.qt')}
                ],
                // 驗證規則
                rules: {
                    phone: [
                        { required: true, message: ' ', trigger: 'blur' },// this.$t('login.phoneinputp')
                    ],
                    code: [
                        { required: true, message: ' ', trigger: 'blur' },//this.$t('login.vscodep')
                    ],
                }
            };
        },
        beforeCreate(){
            // let aaa = '';
            let _this = this;
            if(_this.$route.query.lang){
                _this.$i18n.locale = _this.$route.query.lang;
                localStorage.setItem("lang", _this.$route.query.lang);
            }else if(localStorage.getItem('lang') && (localStorage.getItem('lang') == 'big5' || localStorage.getItem('lang') == 'gb' || localStorage.getItem('lang') == 'eng')){
                _this.$i18n.locale = localStorage.getItem('lang');
            }else{
                _this.$i18n.locale = 'big5';
                localStorage.setItem("lang",'big5');
            }
        },
		mounted() {
            if (this.$i18n.locale == "eng") {
                this.yyFlag = true;
            }else{
                this.yyFlag = false;
            }
            
        },
		methods: {
			yxClick(){
				const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
				 if (!emailRegex.test(this.form.email) && this.form.email) {
					this.flag3 = true
					return
				} else {
					this.flag3 = false
				}
			},
			tabClick(val){
				if(val == 1){
					this.numFlag = true
				}else{
					this.numFlag = false
				}
				this.form.qh = '852'
				this.form.phone = ''
				this.form.email = ''
				this.form.code = ''
				this.flag1 = false
				this.flag2 = false
				this.flag3 = false
			},
			// 切换语言
            language(v){
                if (v == 1) {
                    this.$router.push({query:{lang:'eng'}})
                    // this.$i18n.locale = 'eng'
                    this.yyFlag = true;
                }
                if (v == 2) {
                    this.$router.push({query:{lang:'big5'}})
                    // this.$i18n.locale = 'big5'
                    this.yyFlag = false;
                }
                this.$router.go(0);

            },
			qhclick(val){
				if(!val){
					this.qhflag = true
				}else{
					this.qhflag = false
				}
				console.log(this.qhflag);
				
			},
            // 切換語言
            changeLanFn(lan){
                let _this = this;
                _this.$i18n.locale = lan;
                localStorage.setItem("lang", lan);
                _this.qhArr = [
                    {id:'1',value: '86',label: _this.$t('login.zgdl')}, 
                    {id:'2',value: '852',label: _this.$t('login.zgxg')}, 
                    {id:'3',value: '853',label: _this.$t('login.zgam')}, 
                    {id:'4',value: '61',label: _this.$t('login.adly')}, 
                    {id:'5',value: '1',label: _this.$t('login.jnd')},
                    {id:'6',value: '60',label: _this.$t('login.mlxy')},
                    {id:'7',value: '1',label: _this.$t('login.mg')},
                    {id:'8',value: '65',label: _this.$t('login.xjp')},
                    {id:'9',value: '64',label: _this.$t('login.xxl')}, 
                    {id:'10',value: '44',label: _this.$t('login.yg')},
                    {id:'11',value: '',label: this.$t('login.qt')}
                ];
                _this.rules.phone[0].message = _this.$t('allpage.qtxbtx');
                _this.rules.code[0].message = _this.$t('allpage.qtxbtx');
                _this.$refs['form'].resetFields();
            },
            submitForm(){
				console.log(this.websta);
				this.handenter++;
                let _this = this;
                // _this.$refs['form'].validate((valid) => {
                //     if (valid) {

                //     } else {
                //         return false;
                //     }
                // });
				if (this.numFlag) {
					// 手機號登入
					if (!this.form.phone) {
						this.flag1 = true
						return
					}else{
						this.flag1 = false
					}
					if (!this.form.code) {
						this.flag2 = true
						return
					}else{
						this.flag2 = false
					}
				}else{
					// 郵箱登入
					if (!this.form.phone) {
						this.flag1 = true
						return
					}else{
						this.flag1 = false
					}

					if (!this.form.email) {
						this.flag3 = true
						return
					}else{
						this.flag3 = false
					}
					
					if (!this.form.code) {
						this.flag2 = true
						return
					}else{
						this.flag2 = false
					}

				}

				https.fetchLoginPost(apiUrl.register,{
					nationcode: _this.form.qh,
					phonenum: _this.form.phone,
					email: _this.form.email,
					language: _this.$i18n.locale,
					loginarea: 4,
					captcha: _this.form.code
				}).then((data) => {
					if(Object.is(data.qmiscode,1000)){
						if(data.moveto == 9){
							_this.$router.push({name: 'finish',params:{progress:data.progress}});
							return;
						}else{
							console.log(data);
							data.phone = _this.form.phone;
							_this.$store.commit('adminlogin',data);
							App.oTool.successT(_this.$t('login.success'),2000,()=>{
								_this.$router.push({path: '/main/checkPdf'});
							})
						}
					}else{
						App.oTool.warningT(data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
            },
            codeFn(){
                let _this = this;
				console.log(_this.form,_this.$t('login.yanzhengma'))
                if(!Object.is(_this.$t('login.yanzhengma'),_this.form.codeIndex)){
                    return
                }
                // _this.$refs['form'].validateField('phone',(valid) => {
                //     if (!valid) {
   
                //     } else {
                //         return false;
                //     }
                // });
				var loginType
				if (this.numFlag) {
					// 手機號登入
					if (!this.form.phone) {
						this.flag1 = true
						return
					}else{
						this.flag1 = false
					}
				}else{
					loginType = 'email'

					// 郵箱登入
					if (!this.form.phone) {
						this.flag1 = true
						return
					}else{
						this.flag1 = false
					}

					if (!this.form.email) {
						this.flag3 = true
						return
					}else{
						this.flag3 = false
					}

				}

				https.fetchLoginPost(apiUrl.getVerificationCode,{
					loginType : loginType,
					email: _this.form.email,
					nationcode: _this.form.qh,
					phonenum: _this.form.phone,
					language: _this.$i18n.locale
				}).then((data) => {
					if(Object.is(data.qmiscode,1000)){
						App.oTool.successT(data.qmismsg,2000)
						_this.form.codeIndex = 60;
						let timer = setInterval(() => {
							if(_this.form.codeIndex <= 1){
								_this.form.codeIndex = _this.$t('login.yanzhengma');
								clearInterval(timer);
								return
							}
							_this.form.codeIndex --;
						},1000)
					}else{
						App.oTool.warningT(data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
            }
        },
    };
</script>
